import script from "./CancelationSubSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelationSubSuccess.vue?vue&type=script&setup=true&lang=js"

import "./CancelationSubSuccess.vue?vue&type=style&index=0&id=031720fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-031720fc"]])

export default __exports__